"use client";

import { useUserMe } from "@/contexts/UserMeContext";
import { isPredictAllowed } from "@/lib/predict-access";

/**
 * Whether to show the Predict.fun UI for the CURRENT user — true when the global
 * ENABLE_PREDICT flag is on, or when the logged-in user is in the Predict
 * allowlist (NEXT_PUBLIC_PREDICT_ALLOWLIST, default `zeroxitadori`). Lets us
 * dogfood Predict in prod for one account without exposing it to everyone.
 */
export function usePredictEnabled(): boolean {
  const { user } = useUserMe();
  return isPredictAllowed((user as { username?: string | null } | null)?.username);
}
